import React from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/images/info-i-icon.svg';
import { ReactComponent as QuestionInfoIcon } from '../../../assets/images/circle-questionmark.svg';
import styles from './InfoTooltip.module.css';

const InfoTooltip = ({ infoType, message, customClass = '' }) => {
    if (infoType === 'questionInfo') {
        return (
            <span className={styles.onsiteInfo}>
                <QuestionInfoIcon />
                <span className={`${styles.onsiteInfoTooltiptext} ${customClass}`}>{message}</span>
            </span>
        );
    }

    return (
        <span className={styles.onsiteInfo}>
            <InfoIcon />
            <span className={`${styles.onsiteInfoTooltiptext} ${customClass}`}>{message}</span>
        </span>
    );
};

export default InfoTooltip;
